
import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Header({islogin, setIslogin}) {
 const navigate =   useNavigate()

    const logiout = () =>{
        setIslogin(false)
        localStorage.removeItem("token")
         navigate("/");
    }


    return (
        <>
            {/* Header Top Section */}
            <div className="backdrop"></div>
            <a className="backtop fas fa-arrow-up" href="#"></a>
            <header className="header-top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-5">
                            <div className="header-top-welcome">
                                <p>Welcome to citymart in Your Dream Online Store!</p>
                            </div>
                        </div>

                    

                                
                       

                       
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
